import { Status } from '@okta/odyssey-react-mui';
import { useTranslation } from 'react-i18next';

const EventStatus = ({approvalState, endDate}) => {
    const {t} = useTranslation();

    if(new Date(endDate).getTime() < new Date().getTime()) {
        return <Status label={t('event-state-in-past',{ns:'events'})} severity='default'/>
    }

    switch(approvalState){
        case 'approved':
            return <Status label={t('event-state-approved',{ns:'events'})} severity='success'/>
        case 'pending':
            return <Status label={t('event-state-pending',{ns:'events'})} severity='warning'/>
        case 'unapproved':
            return <Status label={t('event-state-unapproved',{ns:'events'})} severity='error'/>
        default:
            return <Status label={approvalState} severity='default'/>
    }
}

export default EventStatus;